import { SortByEnum } from '../../../domain/sortBy.enum'
import { StartupModel } from '../../../domain/startup.model'

const toTimestamp = (val: string | null | undefined): number | null => {
  if (val === null || val === undefined) return null
  const ts = new Date(val).getTime()
  return isNaN(ts) ? null : ts
}

export const sortStartupsBy = (
  startups: StartupModel[],
  sortBy: SortByEnum,
): StartupModel[] => {
  switch (sortBy) {
    case SortByEnum.DATE_DESC:
      const startupsWithoutDate = startups.filter(
        (s) => toTimestamp(s.validateDate) === null,
      )
      const startupsWithDate = startups
        .filter((s) => toTimestamp(s.validateDate) !== null)
        .sort(
          (a, b) =>
            toTimestamp(b.validateDate)! - toTimestamp(a.validateDate)!,
        )
      return [...startupsWithDate, ...startupsWithoutDate]
    case SortByEnum.DATE_ASC:
      return [...startups].sort((a, b) => {
        const aTs = toTimestamp(a.validateDate)
        const bTs = toTimestamp(b.validateDate)
        if (aTs === null) return 1
        if (bTs === null) return -1
        return aTs - bTs
      })
    case SortByEnum.NAME_DESC:
      return [...startups]
        .sort((a, b) =>
          Intl.Collator().compare(a.informations.name, b.informations.name),
        )
        .reverse()
    case SortByEnum.NAME_ASC:
      return [...startups].sort((a, b) =>
        Intl.Collator().compare(a.informations.name, b.informations.name),
      )
    default:
      return startups
  }
}
